import {
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
  Button,
} from "@mui/material";
import { useState, useEffect } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SendIcon from "@mui/icons-material/Send";
import CancelIcon from "@mui/icons-material/Cancel";
import { updateLawyer } from "../../services/LawyerService";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import AppDialog from "../General/Dialog/AppDialog";

export default function PasswordModal({
  open,
  onClose,
  lawyerId,
  onSuccess,
  setError,
}) {
  const [form, setForm] = useState({
    password: "",
    password_confirmation: "",
  });
  const [errors, setErrors] = useState({});
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  useEffect(() => {
    if (open) {
      setForm({
        password: "",
        password_confirmation: "",
      });
      setErrors({});
      setShowPassword1(false);
      setShowPassword2(false);
    }
  }, [open]);

  const validate = () => {
    const temp = {};

    if (!form.password) {
      temp.password = "Contraseña requerida";
    } else if (form.password.length < 6) {
      temp.password = "Mínimo 6 caracteres";
    }

    if (!form.password_confirmation) {
      temp.password_confirmation = "Debe confirmar la contraseña";
    } else if (form.password !== form.password_confirmation) {
      temp.password_confirmation = "Las contraseñas no coinciden";
    }

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!validate()) return;

    try {
      const formData = new FormData();
      formData.append("password", form.password);
      formData.append("password_confirmation", form.password_confirmation);

      const response = await updateLawyer(lawyerId, formData, true);

      if (response.data?.status === "success") {
        onSuccess(response.data.message);
        onClose();
      }
    } catch {
      setError("Error al actualizar la contraseña.");
    }
  };

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      title="Actualizar Contraseña"
      description="Ingrese la nueva contraseña recuerde que debe ser la misma que SAC"
      icon={<LockOpenOutlinedIcon />}
      actions={
        <>
          <Button variant="outlined" onClick={onClose} endIcon={<CancelIcon />}>
            Cancelar
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            endIcon={<SendIcon />}
          >
            Actualizar
          </Button>
        </>
      }
    >

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        <FormControl
          fullWidth
          variant="outlined"
          sx={{ mb: 2 }}
          error={!!errors.password}
        >
          <InputLabel>Nueva Contraseña</InputLabel>
          <OutlinedInput
            type={showPassword1 ? "text" : "password"}
            name="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword1(!showPassword1)}
                  edge="end"
                >
                  {showPassword1 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Nueva Contraseña"
          />
          <FormHelperText>{errors.password}</FormHelperText>
        </FormControl>

        <FormControl
          fullWidth
          variant="outlined"
          error={!!errors.password_confirmation}
        >
          <InputLabel>Confirmar Contraseña</InputLabel>
          <OutlinedInput
            type={showPassword2 ? "text" : "password"}
            name="password_confirmation"
            value={form.password_confirmation}
            onChange={(e) =>
              setForm({ ...form, password_confirmation: e.target.value })
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword2(!showPassword2)}
                  edge="end"
                >
                  {showPassword2 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Confirmar Contraseña"
          />
          <FormHelperText>{errors.password_confirmation}</FormHelperText>
        </FormControl>
      </Box>
    </AppDialog>
  );
}
